import { themeColors } from "../../config.js";
export default {
  noteRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    alignSelf: "stretch",
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
    border: "1px solid rgba(255,255,255,0.5)",
  },
  component: {
    flex: 1,
    alignSelf: "stretch",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    fontFamily: "roboto",
    fontSize: 15,
    overflow: "hidden",
  },
  full: {
    display: "flex",
    position: "absolute",
    flexDirection: "column",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    overflow: "auto",
  },
  title: {
    margin: 5,
    fontWeight: "bold",
  },
  date: {
    fontSize: 10,
    margin: 5,
  },
  titleCol: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  controlBtn: {
    display: "flex",
    flexDirection: "row",
  },
  noteContent: {
    flex: 1,
    alignSelf: "stretch",
    margin: 5,
    color: themeColors.optionTextColor,
    outline: "none",
    overflow: "auto",
  },
  noteMenu: {
    height: 25,
    width: "100%",
    backgroundColor: themeColors.optionColor,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  menuButton: {
    width: 25,
    height: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: themeColors.borderColor,
    backgroundColor: themeColors.optionColor,
    color: themeColors.optionTextColor,
  },
};
